// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2m5hy","messages":"Chat_messages__2FljN","dateDivider":"Chat_dateDivider__T0OQr"};